const roles = [
    {
        id: "users",
        name: "View Users",
    },
    {
        id: "restaurant",
        name: "View Restaurants",
    },
    {
        id: "riders",
        name: "View Riders",
    },
    {
        id: "nukkadapproval",
        name: "Approve Nukkads",
    }   ,
    {
        id: "riderapproval",
        name: "Approve Riders",
    },
    {
        id:"wallet",
        name:"View Wallet"
    },
    {
        id: "paymentrequest",
        name: "View Payment Requests",
    },
    {
        id: "complaints",
        name: "View Complaints",
    },
    {
        id: "orders",
        name: "View Orders",
    },
    {
        id: "transactions",
        name: "View Transactions",
    },
   
    {
        id: "subadminregis",
        name: "Register Sub-Admins",
    },
    {
        id:"referrallink",
        name:"View Referral Link"
    },
    {
        id: "subadmins",
        name: "View Sub-Admins",
    },

    {
        id:"addcity",
        name:"Add City"
    },

]


export default roles
